module.exports = __webpack_public_path__ + "bdfc00f6988fa5b5e6a704ef763222f3.png";